import api from '@pray/shared/utils/api';

export async function uploadPrayRadioDailyItem({
  artistId,
  contentArtistId,
  title,
  audioUrl,
  audioFileDuration,
  audioFileSize,
  audioFileName,
  scheduledAt,
}: {
  artistId: string;
  contentArtistId?: string;
  title?: string;
  audioUrl: string;
  audioFileDuration: number;
  audioFileSize: number;
  /** The file name as the browser reported it; shown read-only in the editor. */
  audioFileName?: string;
  /** ISO slot start. When given the item is created already scheduled; omitted, it's created unscheduled. */
  scheduledAt?: string;
}) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/pray-radio-dailies/upload`;
  const data = {
    audio_url: audioUrl,
    audio_file_duration: audioFileDuration,
    audio_file_size: audioFileSize,
    ...(audioFileName && { audio_file_name: audioFileName }),
    ...(title && { title }),
    ...(contentArtistId && { artist_id: contentArtistId }),
    ...(scheduledAt && { scheduled_at: scheduledAt }),
  };

  const response = await api.executePostRequest(url, data);
  return response.data;
}
